export default __webpack_public_path__ + "static/media/uae.262abb71.svg";